"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CanvasComponentRendererProvider = void 0;
/**
 * @public
 * Canvas implementation of {@link IComponentRendererProvider}.
 */
class CanvasComponentRendererProvider {
    constructor(context) {
        this.context = context;
    }
    getRenderer() {
        return this.context;
    }
    initializeRenderer() {
        return this.context;
    }
    onContextLost() {
        // no action is required
    }
    reinitializeRenderers() {
        // no action is required
    }
}
exports.CanvasComponentRendererProvider = CanvasComponentRendererProvider;
//# sourceMappingURL=canvas-component-renderer-provider.js.map